import { FC } from 'react'
import { CreditCardPanePreset } from 'components/features/creditCard/creditCardPanes/CreditCardPanePreset'

const YourStatementsPane: FC<{}> = () => {
  return (
    <CreditCardPanePreset title='Your Statements'>
      <p>
        Your statements get emailed to you monthly. To find them please check your
        inbox for emails from
      </p>
      <a href='mailto:donotreply@railz.com' target='_blank'>
        donotreply@railz.com
      </a>
    </CreditCardPanePreset>
  )
}

export default YourStatementsPane
